import { OmniaObjectType } from "./exports"
import { ISeedRatePlan } from "./types"

export function getPlanActivity(create: boolean, plan: ISeedRatePlan) {

    return {
        action: create ? "c" : "u",
        resourceId: plan?.SeedRatePlanId,
        resourceType: OmniaObjectType.SeedPlan,
        year: plan.YearId,
        data: {
            Name: plan?.Name
        }
    }

}
